let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lFI21")).then(() => parcelRequire('bcdUz'));